module.exports = __webpack_public_path__ + "static/media/Catamarca.9b4107b6.svg";